import React from "react";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <div className="footer py-2 border-top">
      <div className="container text-center">
        <p className="mb-0 small">
          {/* new ui changes */}© {year}{" "}
          <strong className="text-primary">CrickPay</strong>. All Rights
          Reserved.
        </p>
      </div>
    </div>
  );
};

export default Footer;
